import React, { useMemo } from 'react';
import { AppStore, createStore, ErrorBoundary, Loading, Redoc, RedocNormalizedOptions, RedocRawOptions, StoreBuilder } from 'redoc';

import { useEndpointTester } from './components/EndpointTester/EndpointTester';
import { GlobalCssVars } from './styles/Global';
import { Splash } from './components/Splash/Splash';

function App() {
    const appContainerRef = React.useRef<HTMLDivElement>(null);

    const { options, normOptions } = useMemo(() => {
        const options: RedocRawOptions = {
            hideDownloadButton: false,
            hideHostname: false,
            scrollYOffset: 0,
            menuToggle: true,
            hideSchemaPattern: false,
            hideSchemaTitles: false,
            pathInMiddlePanel: false,
            hideRequestPayloadSample: false,
            expandResponses: '',
            showObjectSchemaExamples: true,
        };
        const normOptions = new RedocNormalizedOptions(options);
        return { normOptions, options };
    }, []);

    return (
        <div ref={appContainerRef}>
            <GlobalCssVars />
            <ErrorBoundary>
                <StoreBuilder specUrl="./cloudsaver-apis.yml" options={options}>
                    {({ loading, store }) => (
                        <>
                            <Splash visible={loading} />
                            {loading ? null : <AppStoreReady store={store!} />}
                        </>
                    )}
                </StoreBuilder>
            </ErrorBoundary>
        </div>
    );
}

function AppStoreReady({ store }: { store: AppStore }) {
    const { component: tester } = useEndpointTester(store);

    return (
        <>
            <Redoc store={store!} />
            {tester}
        </>
    );
}

export default App;
